import * as types from './actionTypes';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  loading: false,
  contributorData: [],
  contributorDrafts: [],
});

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.LOAD_DATA:
      return {
        ...state,
        loading: false,
        contributorData: action.contributorData,
        contributorDrafts: action.contributorDrafts,
      };
    default:
      return { ...state };
  }
}

//Selectors
export function getValue(state, key) {
  const value = state['contributerDashboard'][key];
  switch (key) {
    default:
      return value;
  }
}
export function getAllValues(state, key) {
  return state['contributerDashboard'];
}
